var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72559 0.151367C3.58559 0.151367 0.225586 3.59826 0.225586 7.84533C0.225586 12.0924 3.58559 15.5393 7.72559 15.5393C11.8656 15.5393 15.2256 12.0924 15.2256 7.84533C15.2256 3.59826 11.8656 0.151367 7.72559 0.151367ZM7.72559 2.45956C8.97059 2.45956 9.97559 3.49055 9.97559 4.76775C9.97559 6.04495 8.97059 7.07594 7.72559 7.07594C6.48059 7.07594 5.47559 6.04495 5.47559 4.76775C5.47559 3.49055 6.48059 2.45956 7.72559 2.45956ZM7.72559 13.385C5.85059 13.385 4.19309 12.4002 3.22559 10.9075C3.24809 9.37643 6.22559 8.53779 7.72559 8.53779C9.21809 8.53779 12.2031 9.37643 12.2256 10.9075C11.2581 12.4002 9.60059 13.385 7.72559 13.385Z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.04da760dee4ca011970f3591330fb105.svg";
export { ForwardRef as ReactComponent };